"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _DualPanePage = _interopRequireDefault(require("../01_atoms/DualPanePage"));

var _Page = _interopRequireDefault(require("../01_atoms/Page"));

var _HomeTopBar = _interopRequireDefault(require("../02_molecules/HomeTopBar"));

var _TicketRightPane = _interopRequireDefault(require("../02_molecules/TicketRightPane"));

var _OrdersListWidget = _interopRequireDefault(require("../03_organisms/OrdersListWidget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var OrdersPage = function OrdersPage(_ref) {
  var tickets = _ref.tickets,
      isFiltered = _ref.isFiltered,
      onUnfilter = _ref.onUnfilter,
      _ref$ticket = _ref.ticket,
      ticket = _ref$ticket === void 0 ? null : _ref$ticket,
      translationManager = _ref.translationManager,
      translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace('OrdersPageUI');
  return /*#__PURE__*/_react["default"].createElement(_Page["default"], null, /*#__PURE__*/_react["default"].createElement(_HomeTopBar["default"], {
    translatorForNamespace: translatorForNamespace,
    selectedTab: "orders"
  }), /*#__PURE__*/_react["default"].createElement(_DualPanePage["default"], _extends({
    leftComponent: _OrdersListWidget["default"],
    rightComponent: ticket && function (_ref2) {
      var _ref2$scrollTop = _ref2.scrollTop,
          scrollTop = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;
      return /*#__PURE__*/_react["default"].createElement(_TicketRightPane["default"], {
        scrollTop: scrollTop,
        focusedLeftItemId: "ticket-thumb_".concat(ticket.id),
        ticket: ticket,
        translationManager: translationManager,
        translatorForNamespace: translatorForNamespace
      });
    }
  }, {
    tickets: tickets,
    isFiltered: isFiltered,
    onUnfilter: onUnfilter,
    translationManager: translationManager,
    translatorForNamespace: translatorForNamespace,
    translator: t
  })));
};

var _default = OrdersPage;
exports["default"] = _default;